import React from "react";
import { Link } from "react-router-dom";
import { Phone, MapPin, Clock, Instagram } from "lucide-react";
import { motion } from "framer-motion";
import { useScrollAnimation } from "../hooks/useScrollAnimation";
import "./ContactTeaser.css";

const ContactTeaser = () => {
  const [ref, isVisible] = useScrollAnimation(0.15);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.2,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 40, scale: 0.95 },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
      },
    },
  };

  const titleVariants = {
    hidden: { opacity: 0, y: -30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  const contactInfo = [
    {
      icon: Phone,
      label: "Call Us",
      value: "+91 95856 93060",
      href: "tel:+919585693060",
      isLink: true,
    },
    {
      icon: MapPin,
      label: "Location",
      value: "10A, kaveri street, vembu avanu, Vadavelli, Coimbatore - 641041",
      isLink: false,
    },
    {
      icon: Clock,
      label: "Hours",
      value: "Mon - Sat: 9 AM - 8 PM",
      isLink: false,
    },
    {
      icon: Instagram,
      label: "Follow Us",
      value: "@senbagampalanisamy561",
      href: "https://www.instagram.com/senbagampalanisamy561?utm_source=qr&igsh=dmZ3cnlnNmk3eGl2",
      isLink: true,
      external: true,
    },
  ];

  return (
    <section className="contact-teaser-section" ref={ref}>
      <div className="contact-teaser-container">
        <motion.h2
          className="contact-teaser-title"
          variants={titleVariants}
          initial="hidden"
          animate={isVisible ? "visible" : "hidden"}
        >
          Get in Touch
        </motion.h2>
        <motion.p
          className="contact-teaser-subtitle"
          variants={titleVariants}
          initial="hidden"
          animate={isVisible ? "visible" : "hidden"}
        >
          Visit our shop or reach out to book your consultation
        </motion.p>

        <motion.div
          className="contact-info-grid"
          variants={containerVariants}
          initial="hidden"
          animate={isVisible ? "visible" : "hidden"}
        >
          {contactInfo.map((item, index) => {
            const IconComponent = item.icon;
            return (
              <motion.div
                key={index}
                className="contact-info-item"
                variants={cardVariants}
                whileHover={{
                  y: -8,
                  transition: { duration: 0.3 },
                }}
              >
                <motion.div
                  className="contact-icon"
                  whileHover={{
                    scale: 1.1,
                    rotate: [0, -10, 10, 0],
                    transition: { duration: 0.5 },
                  }}
                >
                  <IconComponent size={24} />
                </motion.div>
                <h3 className="contact-info-label">{item.label}</h3>
                {item.isLink ? (
                  <a
                    href={item.href}
                    className="contact-info-value"
                    {...(item.external && {
                      target: "_blank",
                      rel: "noopener noreferrer",
                    })}
                  >
                    {item.value}
                  </a>
                ) : (
                  <p className="contact-info-value">{item.value}</p>
                )}
              </motion.div>
            );
          })}
        </motion.div>

        <motion.div
          className="contact-teaser-cta"
          initial={{ opacity: 0, y: 30 }}
          animate={isVisible ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.6, delay: 0.8 }}
        >
          <Link to="/contact" className="contact-cta-button">
            Visit Contact Page
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default ContactTeaser;
